import { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import SiteBar from 'src/components/siteBar/siteBar';
import Footer from 'src/components/footer';
import Alert from 'src/typescript/components/alert/alert';
import Modal from 'src/modules/shared/modal/components/modalRoot';
import Head from 'src/utils/head';
import { clearCurrentCommunity } from 'src/modules/shared/context/actions';
import classNames from 'classnames';
import VerificationBar from 'src/components/verificationBar';

const DefaultLayout = (props) => {
  const {
    children,
    showVerificationBar,
    fullWidth,
    seo,
    siteContainerClassName,
    currentUser,
    clearCurrentCommunity,
    currentCommunityExists,
  } = props;

  useEffect(() => {
    if (currentCommunityExists) {
      clearCurrentCommunity();
    }
  }, []);

  const pageContainerClassNames = classNames({
    'default-page-container': !fullWidth,
    'full-width-page-container': fullWidth,
    'content-top-margin': true,
  });

  return (
    <Fragment>
      <Head {...seo} extra={props.head} />
      <div className={siteContainerClassName}>
        <SiteBar />
        {currentUser && showVerificationBar && <VerificationBar />}
        <Alert />
        <main className={pageContainerClassNames} role="main">
          {children}
        </main>
        <Modal />
      </div>
      <Footer />
    </Fragment>
  );
};

DefaultLayout.defaultProps = {
  seo: undefined, // undefined otherwise seoDefaults is not used
  fullWidth: false,
};

export function mapStateToProps(state) {
  return {
    alert: state.alert.alert,
    currentUser: state.context.currentUser,
    currentCommunityExists: !!state.context.currentCommunity,
    showVerificationBar: state.context.showVerificationBar,
  };
}

export default connect(mapStateToProps, { clearCurrentCommunity })(DefaultLayout);
